const PlanningExportLevelsEnum = {
  Service: 'service',
  Item: 'item',
  Detail: 'detail',
};

export default PlanningExportLevelsEnum;
